import { render, staticRenderFns } from "./ProjectContentMessages.vue?vue&type=template&id=b878d8aa"
import script from "./ProjectContentMessages.vue?vue&type=script&lang=ts"
export * from "./ProjectContentMessages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports